module.exports = __webpack_public_path__ + "img/keaysm.79e2d030.jpg";